module.exports = new __parcel__URL__("spotlightImage.0949772a.png").toString();